module.exports = __webpack_public_path__ + "static/media/uploadhint.52ebc009.svg";